var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculadoraBovedillaHormigon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1020.5 453.5",
    style: {
      enableBackground: "new 0 0 1020.5 453.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#49535A;}\n\t.st1{fill:none;stroke:#169ED7;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{fill:#169ED7;}\n\t.st3{fill:#BDC6C6;stroke:#169ED7;stroke-width:4;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#169ED7;stroke-width:4;stroke-miterlimit:10;}\n\t.st5{fill:#E0E0E0;stroke:#169ED7;stroke-width:4;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_00000101078351964510233140000010048457030377937547_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dibujo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M455.6,422.1c-0.2-0.6-0.3-1.5-0.4-2.6c-0.6,0.9-1.3,1.7-2.3,2.2s-1.9,0.8-3,0.8c-1.6,0-2.9-0.5-3.8-1.4 s-1.4-2.2-1.4-4c0-1.9,0.6-3.3,1.9-4.4s3-1.6,5.3-1.7h3.3v-2.7c0-1.4-0.3-2.3-1-2.9s-1.7-0.9-3-0.9c-1.2,0-2.2,0.4-3,1.1 s-1.2,1.6-1.2,2.7l-2,0c0-1.6,0.6-2.9,1.8-4s2.6-1.6,4.4-1.6c1.9,0,3.4,0.5,4.3,1.4s1.5,2.4,1.5,4.2v9.3c0,1.9,0.2,3.3,0.5,4.2 v0.2H455.6z M450.2,420.5c1.1,0,2.2-0.3,3-0.9s1.5-1.4,1.9-2.4v-4.6h-3.1c-1.8,0-3.1,0.4-4,1.2s-1.4,1.8-1.4,3.1 C446.7,419.3,447.9,420.5,450.2,420.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.3,403l0.1,3c0.6-1,1.3-1.9,2.2-2.5s1.9-0.9,3-0.9c3.3,0,5,2.2,5.1,6.6v12.7h-1.9v-12.5 c0-1.7-0.3-3-0.9-3.8s-1.5-1.2-2.8-1.2c-1,0-1.9,0.4-2.8,1.2s-1.4,1.8-1.9,3.2v13.2h-2v-19H464.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M485.8,420.6c1.4,0,2.4-0.4,3.1-1.1s1.1-1.9,1.2-3.3h1.9c-0.1,1.9-0.7,3.5-1.9,4.6s-2.6,1.7-4.3,1.7 c-2.3,0-4-0.7-5.1-2.2s-1.7-3.6-1.8-6.4v-2.3c0-2.9,0.6-5.1,1.7-6.6s2.9-2.2,5.1-2.2c1.9,0,3.4,0.6,4.5,1.8s1.7,2.9,1.7,5h-1.9 c-0.1-1.6-0.5-2.8-1.2-3.6s-1.8-1.3-3.1-1.3c-1.7,0-2.9,0.6-3.7,1.7s-1.2,2.9-1.2,5.2v2.2c0,2.4,0.4,4.2,1.2,5.3 S484.1,420.6,485.8,420.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M498.1,406c0.6-1,1.3-1.8,2.1-2.4s1.8-0.9,3-0.9c3.3,0,5,2.2,5.1,6.6v12.7h-1.9v-12.5c0-1.7-0.3-3-0.9-3.8 s-1.5-1.2-2.8-1.2c-1,0-1.9,0.4-2.8,1.2s-1.4,1.8-1.9,3.2v13.2h-2v-27h2V406z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512.7,411.6c0-2.7,0.6-4.9,1.9-6.5s2.9-2.4,5.1-2.4c2.2,0,3.9,0.8,5.1,2.4s1.9,3.7,1.9,6.5v2 c0,2.8-0.6,5-1.9,6.5s-2.9,2.3-5.1,2.3s-3.8-0.8-5-2.3s-1.9-3.6-1.9-6.3V411.6z M514.7,413.5c0,2.2,0.4,3.9,1.3,5.2 c0.9,1.3,2.1,1.9,3.7,1.9c1.6,0,2.8-0.6,3.7-1.8s1.3-2.9,1.3-5.2v-2c0-2.2-0.4-3.9-1.3-5.2s-2.1-1.9-3.7-1.9 c-1.5,0-2.7,0.6-3.6,1.8s-1.3,2.9-1.4,5.1V413.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M965.6,206.4h-2v-27h2V206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M981.2,204.1c-1.1,1.7-2.7,2.6-5,2.6c-1.7,0-3-0.6-3.9-1.8s-1.3-3-1.3-5.3v-12.3h1.9v12.3 c0,1.7,0.3,3,0.9,3.9s1.5,1.3,2.6,1.3c2.5,0,4-1.2,4.7-3.6v-13.9h2v19h-1.9L981.2,204.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M989.7,204.5h10.3v1.8h-12.6v-1.6l9.6-15.6h-9.4v-1.8h11.7v1.6L989.7,204.5z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 981,
    y1: 25.9,
    x2: 981,
    y2: 147.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 21.7,
    className: "st2",
    width: 26,
    height: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 981,
    y1: 361.1,
    x2: 981,
    y2: 239.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 361.3,
    className: "st2",
    width: 26,
    height: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 29.3,
    y1: 411.5,
    x2: 402.1,
    y2: 411.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 569.3,
    y1: 411.5,
    x2: 942.1,
    y2: 411.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.3,
    y: 399,
    className: "st2",
    width: 4,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 939.1,
    y: 399,
    className: "st2",
    width: 4,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.3,
    y: 33.5,
    className: "st3",
    width: 914.8,
    height: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 27.3,
    y1: 73.5,
    x2: 942.1,
    y2: 73.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 27.3,
    y1: 113.5,
    x2: 942.1,
    y2: 113.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 27.3,
    y1: 153.5,
    x2: 942.1,
    y2: 153.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 27.3,
    y1: 193.5,
    x2: 942.1,
    y2: 193.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 27.3,
    y1: 233.5,
    x2: 942.1,
    y2: 233.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 27.3,
    y1: 273.5,
    x2: 942.1,
    y2: 273.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 27.3,
    y1: 313.5,
    x2: 942.1,
    y2: 313.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.3,
    y: 21.7,
    className: "st5",
    width: 14.9,
    height: 343.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.3,
    y: 21.7,
    className: "st5",
    width: 14.8,
    height: 343.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.3,
    y: 21.7,
    className: "st5",
    width: 14.9,
    height: 343.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.3,
    y: 21.7,
    className: "st5",
    width: 14.9,
    height: 343.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.3,
    y: 21.7,
    className: "st5",
    width: 14.9,
    height: 343.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477.3,
    y: 21.7,
    className: "st5",
    width: 14.9,
    height: 343.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 567.3,
    y: 21.7,
    className: "st5",
    width: 14.8,
    height: 343.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 657.3,
    y: 21.7,
    className: "st5",
    width: 14.8,
    height: 343.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 747.3,
    y: 21.7,
    className: "st5",
    width: 14.8,
    height: 343.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837.3,
    y: 21.7,
    className: "st5",
    width: 14.8,
    height: 343.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 927.3,
    y: 21.7,
    className: "st5",
    width: 14.8,
    height: 343.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculadoraBovedillaHormigon);
export default __webpack_public_path__ + "static/media/calculadora-bovedilla-hormigon.e65f69a5807ebac16a5108a93f26b2c3.svg";
export { ForwardRef as ReactComponent };